export const ROLES = {
  MEMBER: 'member',
  OWNER: 'owner',
  ADMIN: 'admin',
} as const;

export interface MerchantRole {
  name: string;
  merchant: { id: string };
}

export const roleForMerchant = (
  merchantId: string | null | undefined,
  roles: MerchantRole[]
): string => {
  const roleObj = roles.find((role) => role.merchant.id === merchantId);
  return roleObj ? roleObj.name : ROLES.MEMBER;
};

export const isAdminOrOwner = ({
  merchantId,
  roles,
  organizationAdmin,
}: {
  merchantId: string | null | undefined;
  roles: MerchantRole[];
  organizationAdmin?: boolean;
}): boolean => {
  if (organizationAdmin) return true;
  const role = roleForMerchant(merchantId, roles);
  return role === ROLES.ADMIN || role === ROLES.OWNER;
};
